<template>
    <div class="modal" ref="modal" @click.self="closeModal" tabindex="0" @keyup.esc="closeModal">
        <div class="custom-modal-content w-640">
            <div class="modal-close" @click="closeModal">
                <icon-close/>
            </div>
            <div v-if="formSent" class="review-success">
                <div class="text-center review-success-image">
                    <IconReviewSuccess/>
                </div>
                <div class="recall-title text-center">Ваш відгук успішно відкликано!</div>
            </div>
            <div v-else>
                <div class="recall-title">Відкликати відгук?</div>
                <div class="recall-text">Ви дійсно бажаєте відкликати відгук? Вкажіть, будь ласка, причину</div>
                <div class="recall-label">Ваша причина</div>
                <textarea name="recallreason" id="recallReason" cols="30" rows="4" v-model="formData.reason"
                          placeholder="" class="recall-area"></textarea>
                <FormErrors v-if="formErrors.recall_reason" :errors="formErrors.recall_reason"/>
                <div class="form-group text-right">
                    <button class="btn btn-outline btn-small" @click="closeModal">Відмінити</button>
                    <button class="btn btn-small" @click="recallTest">Відкликати</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconClose from '../icons/IconClose';
import {tourniquetStore} from "../../store/store";
import $ from "jquery";
import FormErrors from "../helpers/FormErrors.vue";
import IconReviewSuccess from "../icons/IconReviewSuccess.vue";

export default {
    name: "RecallReviewModal",
    components: {IconReviewSuccess, FormErrors, IconClose},
    props: [],
    setup() {
        const store = tourniquetStore();
        return {store};
    },
    data() {
        return {
            formData: {
                id: this.store.recallTestId,
                reason: ''
            },
            formErrors: {},
            formSent: false
        }
    },
    methods: {
        closeModal() {
            this.store.hideRecallModal();
        },
        recallTest() {
            fetch(`/test/${this.formData.id}/recall`, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({'recall_reason': this.formData.reason})
            }).then(res => res.json())
                .then(res => {
                    if(!res.status && res.messages) {
                        this.formErrors = res.messages;
                        return
                    }
                    this.formSent = res.status;
                    this.$emit('recall', this.formData.id);
                }).catch((err) => {
                console.log(err);
            });
        }
    },
    mounted() {
        this.$refs.modal.focus()
    }
}
</script>
<style lang="scss" scoped>

@import "../../../../sass/front/helpers";

.recall {
    &-title {
        font-size: 2rem;
        font-weight: 500;
        margin-bottom: 1.2rem;
    }

    &-text {
        font-weight: 300;
    }

    &-label {
        font-weight: 500;
        margin-top: 2.2rem;
        margin-bottom: 1.2rem;
    }

    &-area {
        width: 100%;
        resize: none;
        padding: 2rem;
        font-size: 1.4rem;
        line-height: 1.6;
        font-family: 'Ukraine';
        background-color: #F8F8F8;
        border: 1px solid #F8F8F8;
        border-radius: 0.8rem;

        &:focus {
            background-color: #fff;
            border-color: $color-brand;
            outline: none;
        }
    }
}
</style>

